class Panel extends HTMLElement {
  constructor() {
    super();
    this.defaultFocus = null;
  }
  connectedCallback() {
    this.addEventListener('custom:escape', this.escape.bind(this));
  }

  escape(e) {
    this.close();
    console.log('ESCAPE PANEL', e);
    panelManager.dispatch('CLOSE_PANEL');
    e.stopImmediatePropagation();
    // if (e.detail.triggerElement) {
    //   console.log('focus', e.detail.triggerElement);
    //   e.detail.triggerElement.focus();
    // }
  }

  transitionFrom(previousState, newState, triggerElement, previousPanel) {
    console.log('Transition from:', previousState, newState, triggerElement);
    this.activate();
    //   previousPanel.deactivate();
    // }
  }

  close() {
    console.log('CLOSE PANEL');
  }

  activate() {
    this.setAttribute('aria-hidden', false);
    this.style.zIndex = 1;
    this.classList.remove('hidden');
    this.updateDrawerAriaLabel();
  }
  deactivate(siblingClose = false) {
    this.style.zIndex = '';
    this.setAttribute('aria-hidden', true);
    this.classList.add('hidden');

    if (!siblingClose && (this.dataset.panelCloseDesktop || this.dataset.panelCloseMobile)) {
      let onCloseFocusElement;

      if (!this.dataset.panelCloseMobile) {
        onCloseFocusElement = document.querySelector(this.dataset.panelCloseDesktop);
      } else if (!this.dataset.panelCloseDesktop) {
        onCloseFocusElement = document.querySelector(this.dataset.panelCloseMobile);
      } else {
        onCloseFocusElement = document.querySelector(
          window.innerWidth <= 767 ? this.dataset.panelCloseMobile : this.dataset.panelCloseDesktop,
        );
      }

      setTimeout(() => {
        onCloseFocusElement.focus();
      }, 64);
    }
  }

  updateDrawerAriaLabel() {
    const drawer = document.getElementById('drawer-content');
    if (drawer && this.dataset.label) {
      drawer.setAttribute('aria-label', this.dataset.label);
    }
  }
}
